module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.clickaway),
      expression: "clickaway"
    }],
    staticClass: "no-print"
  }, [_c('div', {
    staticClass: "sidebar-nav"
  }, [_c('div', {
    staticClass: "nav"
  }, [(_vm.userHasPermission('can_see_other_calendars') || (_vm.userHasMultipleSchools && !_vm.userHasPermission('can_see_other_calendars'))) ? _c('div', {
    staticClass: "docendo-logo box-shadow"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open === false),
      expression: "open === false"
    }],
    staticClass: "docendo-logo__icon icon-docendo",
    on: {
      "click": function($event) {
        return _vm.openSideNav(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open === true),
      expression: "open === true"
    }],
    staticClass: "icon-cross2 font-large",
    staticStyle: {
      "padding": "18px"
    },
    on: {
      "click": _vm.closeSideNav
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.userHasPermission('can_see_other_calendars') && !_vm.userHasMultipleSchools) ? _c('div', {
    staticClass: "docendo-logo docendo-logo__not-active box-shadow"
  }, [_c('span', {
    staticClass: "docendo-logo__icon icon-docendo"
  })]) : _vm._e(), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars') && _vm.activeSchool) ? _c('ul', {
    on: {
      "click": _vm.openSideNav
    }
  }, [(_vm.isKindergarten) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToDutySchedule.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "icons icon-users5 gtm",
    attrs: {
      "data-gtm": "SideNav__club"
    }
  }), _vm._v("\n          Vagtplan\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isKindergarten) ? _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__kindergarten gtm",
    class: {
      active: _vm.isActive(7)
    },
    attrs: {
      "data-gtm": "SideNav__club"
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(7)
      }
    }
  }, [_c('div', {
    staticClass: "icons icon-users5 gtm",
    attrs: {
      "data-gtm": "SideNav__club"
    }
  }), _vm._v("\n          Stuer\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isKindergarten) ? _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__klass gtm test-2",
    class: {
      active: _vm.isActive(1)
    },
    attrs: {
      "data-gtm": "SideNav__klass"
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(1)
      }
    }
  }, [_c('div', {
    staticClass: "icons icon-calendar4 gtm",
    attrs: {
      "data-gtm": "SideNav__klass"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.classes_sidenav')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__users gtm",
    class: {
      active: _vm.isActive(2)
    },
    attrs: {
      "data-gtm": "SideNav__users"
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(2)
      }
    }
  }, [_c('div', {
    staticClass: "icons icon-users gtm",
    attrs: {
      "data-gtm": "SideNav__users"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.users')) + "\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__location gtm",
    class: {
      active: _vm.isActive(3)
    },
    attrs: {
      "data-gtm": "SideNav__location"
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(3)
      }
    }
  }, [_c('div', {
    staticClass: "icons icon-location gtm",
    attrs: {
      "data-gtm": "SideNav__location"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.rooms')) + "\n        ")]), _vm._v(" "), (!_vm.isKindergarten) ? _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__merge gtm",
    class: {
      active: _vm.isActive(4)
    },
    attrs: {
      "data-gtm": "SideNav__merge"
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(4)
      }
    }
  }, [_c('div', {
    staticClass: "icons icon-calendar-week gtm",
    attrs: {
      "data-gtm": "SideNav__merge"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.merge_calendars_sidenav')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__other gtm",
    class: {
      active: _vm.isActive(5)
    },
    attrs: {
      "data-gtm": "SideNav__other"
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(5)
      }
    }
  }, [_c('div', {
    staticClass: "icons icon-clipboard2 gtm",
    attrs: {
      "data-gtm": "SideNav__other"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.common.other_calendars')) + "\n        ")]), _vm._v(" "), (_vm.isSchoolSFOActive && !_vm.isKindergarten) ? _c('li', {
    staticClass: "js-intro js-intro-sidebar-nav__club gtm",
    class: {
      active: _vm.isActive(6)
    },
    attrs: {
      "data-gtm": "SideNav__club"
    },
    on: {
      "click": function($event) {
        return _vm.chooseCals(6)
      }
    }
  }, [_c('div', {
    staticClass: "icons icon-users5 gtm",
    attrs: {
      "data-gtm": "SideNav__club"
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('vue2.club.club')) + "\n        ")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-nav__container",
    class: [{
      sidebar_nav_container_show: _vm.open
    }]
  }, [_c('div', {
    staticClass: "sidebar-nav__container__header box-shadow flex"
  }, [_c('div', {
    staticClass: "flex flex-vertical-center",
    staticStyle: {
      "width": "85%"
    }
  }, [_c('h2', [(_vm.activeSchool) ? _c('a', {
    staticClass: "link-white",
    attrs: {
      "href": '/schools/' + _vm.activeSchool.id
    }
  }, [_vm._v(_vm._s(_vm.activeSchool.name))]) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-down5 arrow-dropdown",
    class: {
      active: _vm.changeSchoolDropdown
    },
    on: {
      "click": _vm.toggleChangeSchoolDropdown
    }
  }), _vm._v(" "), (_vm.changeSchoolDropdown) ? _c('div', {
    staticClass: "sidebar-nav__container--dropdown bg-light-blue box-shadow pos-absolute z-index-1000 text-white width-100 box-sizing"
  }, [_c('list-with-search', {
    attrs: {
      "selected": _vm.activeSchool,
      "options": _vm.allSchools
    },
    on: {
      "choose": _vm.toggleChangeSchoolDropdown
    }
  })], 1) : _vm._e()]), _vm._v(" "), (!_vm.isLoading && _vm.yearCals.length < 1) ? [_c('div', {
    staticClass: "no-cals"
  }, [_c('div', {
    staticClass: "no-cals__icon"
  }, [_c('span', {
    class: _vm.activeType.icon
  })]), _vm._v(" "), _c('p', {
    staticClass: "no-cals__text",
    domProps: {
      "innerHTML": _vm._s(_vm.notCreatedAnyTextString)
    }
  })])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "create-link__container"
  }, [(_vm.isActive(1) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
    staticClass: "create-cal__button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createKlasses.apply(null, arguments)
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 1 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(2) && _vm.userHasPermission('can_manage_users')) ? _c('a', {
    staticClass: "create-cal__button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createUsers.apply(null, arguments)
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 2 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(3) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
    staticClass: "create-cal__button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 3 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isActive(4) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
    staticClass: "create-cal__button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeType.title))]), _vm._v(" "), (_vm.activeOnboardingStep === 4 && _vm.showOnboardingArrow) ? _c('onboardArrow') : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((_vm.isActive(5) || _vm.isActive(6) || _vm.isActive(7)) && _vm.userHasPermission('can_manage_calendars')) ? _c('a', {
    staticClass: "create-cal__button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createCalendars(_vm.activeType.type)
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('vue2.common.create')) + " "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.activeType.title))])]) : _vm._e()]), _vm._v(" "), (_vm.activeType.hasSchoolYear) ? _c('ChangeSchoolYear', {
    staticStyle: {
      "margin": "10px 15px 0"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.yearCals.length > 0) ? _c('div', {
    staticClass: "sidebar-nav__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "searchfield",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('vue2.common.search_for') + ' ' + _vm.searchName,
      "id": "searchfield"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.search !== ''),
      expression: "search !== ''"
    }],
    staticClass: "sidebar-nav__search__cross pointer icon-cross2",
    on: {
      "click": _vm.clearSearch
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars')) ? _c('div', {
    staticClass: "sidebar-nav__container__body"
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('Loader', {
    attrs: {
      "bg-color": "#3e4450"
    }
  })], 1) : [_c('ul', {
    staticClass: "nav__cal-list"
  }, _vm._l((_vm.searchCals), function(cal) {
    return _c('li', {
      key: cal.id
    }, [(cal.type !== 'klass') ? [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
      attrs: {
        "href": cal.url
      }
    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]) : _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.setActiveCalendarId(cal.id)
        }
      }
    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))])] : _vm._e(), _vm._v(" "), (cal.type === 'klass') ? _c('div', {
      staticClass: "nav__cal-list__item",
      class: {
        'nav__cal-list__item--open': _vm.isStudentsActiveForCal(cal.id)
      }
    }, [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
      attrs: {
        "href": cal.url
      }
    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]) : _c('a', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.setActiveCalendarId(cal.id)
        }
      }
    }, [_vm._v(_vm._s(cal.name ? cal.name : cal.url))]), _vm._v(" "), (cal.students && cal.students.length > 0) ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.setTheStudentsActiveForCal(cal.id)
        }
      }
    }, [_c('span', {
      staticClass: "icon-arrow-down52"
    })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isStudentsActiveForCal(cal.id)) ? _c('ul', {
      staticClass: "nav__cal-list__item__students"
    }, _vm._l((_vm.getCalStudents(cal.students)), function(student) {
      return _c('li', [(_vm.userHasPermission('can_do_most_stuff')) ? _c('a', {
        attrs: {
          "href": student.url
        }
      }, [_vm._v(_vm._s(student.name ? student.name : student.url))]) : _c('a', {
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.setActiveCalendarId(student.id)
          }
        }
      }, [_vm._v(_vm._s(student.name ? student.name : student.url))])])
    }), 0) : _vm._e()], 2)
  }), 0)]], 2) : _vm._e()], 2), _vm._v(" "), (_vm.userHasPermission('can_see_other_calendars') && _vm.activeSchool) ? _c('TeamCalendar') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6252f8c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideNav.vue
// module id = 1675
// module chunks = 1